import React, { Component } from "react";

import Headbody from "../../components/head-body";
import Menu from "../../components/menu";
import Devsolucoes from "../../components/dev-solucoes";
import Footer from "../../components/footer";
import Endbody from "../../components/end-body";


class Quemsomos extends Component {
  
    render() {
      return (
          <React.Fragment>
                <Headbody></Headbody>
                <Menu></Menu>
                <section class="header-interno padrao">
                  <div class="container">
                    <h1>Quem Somos</h1>
                  </div>
                </section>

                <section class="conteudo-interno">
                  <div class="container">
                    <div class="row">
                      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <p>ItechMed uma empresa de tecnologia baseada em “internet of things”– IOT, com o propósito de ajudar clínicas e hospitais a melhorar seus processos e principalmente a experiência na jornada do paciente e do médico.</p>
                        
                        <p>Com a plataforma de soluções ItechFlow, também atendemos outros segmentos de mercado, tais como varejo e hotelaria.</p>

                        <p>Geramos e registramos dados em nuvem que são fundamentais para melhorar os processos, transformamos informações em resultados e disponibilizamos tudo com solução de Business Inteligence - BI através de Dash-boards, gráficos e alertas para melhor gestão da operação.</p>
                        <br></br>
                      </div>
                      <div class="col-12">
                        <h3 class="text-center">CASES</h3>
                        <div id="clientes" class="owl-carousel">
                            <img src={"../assets/img/clientes/galeria-afip.jpg"} alt="" class="img-fluid"></img>
                            <img src={"../assets/img/clientes/galeria-lia-maria.jpg"} alt="" class="img-fluid"></img>
                            <img src={"../assets/img/clientes/galeria-sirio-libanes.jpg"} alt="" class="img-fluid"></img>
                            <img src={"../assets/img/clientes/galeria-svri.jpg"} alt="" class="img-fluid"></img>
                          </div>
                      </div>
                    </div>


                    {/* <!-- <div class="row d-lg-flex align-content-lg-center">
                      <div class="col-12 col-lg-5">
                        <img src="assets/img/img-sobre.svg" alt="Imagens de IoT" class="img-fluid">
                      </div>

                      <div class="col-12 col-lg-7">
                        <h3>O que é IoT?</h3>
                        <p>O termo Internet of Things (loT) é usado para descrever a conectividade entre objetos físicos, ou até mesmo pessoas, com a internet – é a digitalização do mundo real. O conceito de loT permite que você tenha análise em tempo real e registro constante de dados de informações sobre objetos e pessoas que antes não era possível. O loT está revolucionando o modo como vivemos, facilitando cada segundo da nossa vida para nos concentrarmos no que importa. É a revolução da produtividade e da melhor utilização dos recursos no mundo! </p>

                        <p>O loT está, sem dúvida, transformando o setor de saúde e outros segmentos ao redefinir os dispositivos e a interação das pessoas. A ItechMed oferece um portfólio de soluções que possibilitam o monitoramento remoto no setor de saúde, liberando o potencial de manter o paciente seguro e saudável e capacitando os profissionais de saúde a fornecer melhores cuidados.</p>

                        <br></br><br></br>
                      </div>
                    </div> --> */}

{/* 
                    <!-- <div class="row">
                      <div class="col-12 offset-md-2 col-md-10">
                        <img src="assets/img/itechFlow.png" class="img-fluid m-auto" alt="Imagem sobre o fluxo de uso do I Tech Flow">
                      </div>
                    </div> --> */}
                  </div>

                </section>

                <Footer></Footer>
                <Endbody></Endbody>
          </React.Fragment>
        
      );
    }
  }

export default Quemsomos;